export const DOCUMENTS_REFETCH_INTERVAL = 30000;
export const DOCUMENTS_SUMMARY_REFETCH_INTERVAL = 60000;
